export default __webpack_public_path__ + "centrifuge.png?458528a1c2713ec879b2c6b1d99fd999";